"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var models_1 = require("./models");
var ConstantCalculation_1 = require("../../transforms/calculations/ConstantCalculation");
function getThresholdFeature(features) {
    return features.threshold;
}
exports.getThresholdFeature = getThresholdFeature;
function getDefaultLineForThreshold(feature) {
    var _a, _b, _c, _d;
    return (_d = (_c = (_b = (_a = feature) === null || _a === void 0 ? void 0 : _a.thresholds) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.lines) === null || _d === void 0 ? void 0 : _d[0];
}
exports.getDefaultLineForThreshold = getDefaultLineForThreshold;
function getLineStyleForDefaultThresholdLine(definition) {
    var _a;
    return (_a = getDefaultLineForThreshold(definition.features.threshold)) === null || _a === void 0 ? void 0 : _a.style;
}
exports.getLineStyleForDefaultThresholdLine = getLineStyleForDefaultThresholdLine;
function getStylePropsForDefaultThresholdLine(definition) {
    var _a;
    var lineStyle = getLineStyleForDefaultThresholdLine(definition);
    return ((_a = lineStyle) === null || _a === void 0 ? void 0 : _a.lineStyle) === models_1.LineStyle.DASHED ? DASHED_LINESTYLE : undefined;
}
exports.getStylePropsForDefaultThresholdLine = getStylePropsForDefaultThresholdLine;
var DASHED_LINESTYLE = {
    strokeDasharray: '1 5',
    strokeLinecap: 'round',
};
exports.shouldRenderFirstThresholdLine = function (definition) {
    return exports.shouldRenderFirstThresholdLineFromFeature(getThresholdFeature(definition.features));
};
exports.shouldRenderFirstThresholdLineFromFeature = function (feature) {
    var _a, _b;
    var line = getDefaultLineForThreshold(feature);
    if (!line) {
        return false;
    }
    var hidden = (_b = (_a = line) === null || _a === void 0 ? void 0 : _a.style) === null || _b === void 0 ? void 0 : _b.hidden;
    return hidden ? false : true;
};
exports.getStaticTargetValue = function (definition) {
    if (!exports.isDefaultLineStaticRefLine(definition)) {
        return undefined;
    }
    var line = getDefaultLineForThreshold(definition.features.threshold);
    if (line === undefined) {
        return undefined;
    }
    var measureCalculation = definition.schema[line.measure.column].calculation;
    if (!ConstantCalculation_1.isConstantCalculation(measureCalculation)) {
        return undefined;
    }
    return measureCalculation.value;
};
exports.isDefaultLineStaticRefLine = function (definition) {
    var line = getDefaultLineForThreshold(definition.features.threshold);
    if (!line || line.timestamp || !definition.schema[line.measure.column]) {
        return false;
    }
    return ConstantCalculation_1.isConstantCalculation(definition.schema[line.measure.column].calculation);
};
//# sourceMappingURL=getters.js.map